import { useState } from 'react';
import { Note } from '../models/Note.interface';
import axios from 'axios';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';
import { useAlertMessage } from 'src/hooks/useAlertMessage';

export const useCreateNote = () => {
  const [note, setNote] = useState<Note>();
  const [loadingNote, setLoadingNote] = useState<boolean>();
  const [responseStatus, setResponseStatus] = useState<number>();
  const {
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
    showAlert,
  } = useAlertMessage();
  const createNote = async (ticketID: string | number, noteText: string, file?: File) => {
    if (loadingNote) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('notetext', noteText);

    try {
      setLoadingNote(true);
      const { data, status } = await axios.post(
        `api/annotations/${ticketID}`,
        formData,
        { headers: { Accept: 'application/json' } }
      );
      data && setNote(data);
      status && setResponseStatus(status);
      analyticsEventSend('New note request posted.');
      showAlert('Note submitted successfully', 'success');
    } catch (err) {
      console.error(err);
      showAlert('Error submitting note.', 'error');
    } finally {
      setLoadingNote(false);
    }
  };

  return { 
    note, 
    loadingNote, 
    createNote, 
    responseStatus,
    requestStatusAppearance,
    requestStatusMessage,
    hideAlert
   };
};
